import { USER_DEMOED_LICENSE_PRODUCTS_RECEIVE } from '../constants';

export const userDemoedLicenseProducts = (
    state = [],
    action
) => {
    switch (action.type) {
        case USER_DEMOED_LICENSE_PRODUCTS_RECEIVE:
            return action.payload;
        default:
            return state;
    }
};
